import React, { Component } from 'react'
import MappingAgeList from '../../../components/MappingAgeList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingAgeConsumer } from '../../../context/MappingAgeContext'

type MappingAgeProps = {
  filters: any | null,
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingAge extends Component<MappingAgeProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, filters, history } = this.props

    return (
      <MappingAgeConsumer>
        {({ fetching, mappingAges, pagination, requestMappingAgeList }) => {

          return <MappingAgeList permissions={permissions} loading={fetching} mappingAges={mappingAges} pagination={pagination} filters={filters} history={history} onLoad={this.handleOnLoad} loadMappingAges={requestMappingAgeList} />
        }}
      </MappingAgeConsumer>
    )
  }
}
